import React from 'react';
import * as Sentry from '@sentry/react';
import { toast } from 'sonner';
import { useLocation } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

const ToastErrorBoundary: React.FC<Props> = ({ children }) => {
  const pathname = useLocation();
  return (
    <Sentry.ErrorBoundary
      fallback={<></>}
      showDialog={false}
      onError={error => {
        toast.error((error as Error).message || 'Unknown error');
        setTimeout(() => {
          if (pathname.pathname === '/') {
            return;
          }
          window.location.href = '/';
        }, 4000);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ToastErrorBoundary;
